var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelect',_vm._b({attrs:{"options":_vm.options,"localized":"","default-option-label":_vm.defaultOptionLabel,"value":_vm.value,"loading":_vm.isLoading},on:{"input:object":_vm.handleSelect}},'FormSelect',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }